module.exports = __webpack_public_path__ + "img/bauger_03.463ce8c2.png";